import { createFileRoute } from "@tanstack/react-router";

import { ConsoleDocsPage } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/docs")({
  component: ConsoleDocsPage,
});
